"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VssxShortcut = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const VssxShortcutSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M6 9.936V2.25a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 .75.75v19.5a.75.75 0 0 1-.75.75H9.796q.142-.245.269-.5H21.25a.25.25 0 0 0 .25-.25V2.25a.25.25 0 0 0-.25-.25H6.75a.25.25 0 0 0-.25.25v7.954a9 9 0 0 0-.5-.268",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.75 2h14.5a.25.25 0 0 1 .25.25v19.5a.25.25 0 0 1-.25.25H10.065A8.96 8.96 0 0 0 11 18c0-3.331-1.81-6.24-4.5-7.796V2.25A.25.25 0 0 1 6.75 2",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#185ABD",
    fillRule: "evenodd",
    d: "M3 7.5h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-1.014q.015-.248.014-.5a9 9 0 0 0-9-9v-.5a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#C8C6C4",
    fillRule: "evenodd",
    d: "M15.75 20.5h3.5a.75.75 0 0 0 .75-.75v-6a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0-.75.75v6a.75.75 0 0 0 .75.75m-.25-6.75a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v6a.25.25 0 0 1-.25.25h-3.5a.25.25 0 0 1-.25-.25zm.25-2.75h3.5a.75.75 0 0 0 .75-.75v-6a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0-.75.75v6a.75.75 0 0 0 .75.75m-.25-6.75a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v6a.25.25 0 0 1-.25.25h-3.5a.25.25 0 0 1-.25-.25zM12.5 19.75v-.32q.265-.07.5-.21v.53a.75.75 0 0 1-.75.75h-1.602q.071-.247.129-.5h1.473a.25.25 0 0 0 .25-.25m-4-15.5V6.5H8V4.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v2.53a2 2 0 0 0-.5-.21V4.25a.25.25 0 0 0-.25-.25h-3.5a.25.25 0 0 0-.25.25",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.388 12.858 10.5 10H9.245l-.656 1.869q.433.465.799.99",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  })]
});
const VssxShortcut = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: VssxShortcutSvg
}));
exports.VssxShortcut = VssxShortcut;